import React from 'react'
import { Form, Input, Switch, InputNumber, Button, FormInstance } from 'antd'

interface RoleFormProps {
  form: FormInstance
  loading: boolean
  onSubmit: () => void
  children?: React.ReactNode
}

export const RoleForm: React.FC<RoleFormProps> = ({ form, loading, onSubmit, children }) => {
  return (
    <Form form={form} layout={'horizontal'} labelCol={{ span: 4 }} wrapperCol={{ span: 12 }}>
      <Form.Item
        label="Название"
        name="name"
        rules={[{ required: true, message: 'Укажите название!' }]}
      >
        <Input autoComplete="new" />
      </Form.Item>

      <Form.Item label="Активна" name="is_active" valuePropName="checked">
        <Switch defaultChecked={form.getFieldValue('is_active')} />
      </Form.Item>

      <Form.Item label="Стартовая страница" name="start_page">
        <Input />
      </Form.Item>

      <Form.Item label="Приоритет" name="priority">
        <InputNumber />
      </Form.Item>

      {children}

      <Form.Item wrapperCol={{ offset: 4, span: 12 }} style={{ marginTop: 30 }}>
        <Button type="primary" htmlType="submit" onClick={onSubmit}>
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  )
}
